var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{attrs:{"outlined":"","elevation":"0"}},[_c('v-card-text',[_c('canvas',{staticClass:"chart-js",staticStyle:{"width":"100%","height":"100%"},attrs:{"id":_vm.name,"aria-label":_vm.name,"role":"img"}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }